
import React from 'react';
import { Input } from "@/components/ui/input";
import { ParcelValidationErrors } from "@/hooks/useParcelValidation";
import ErrorMessage from "./ErrorMessage";

interface OtherTypeSpecificationFieldProps {
  value: string;
  onChange: (value: string) => void;
  errors?: ParcelValidationErrors;
}

const OtherTypeSpecificationField: React.FC<OtherTypeSpecificationFieldProps> = ({
  value,
  onChange,
  errors = {}
}) => {
  return (
    <div className="mt-2">
      <Input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Please specify the type of parcel"
        className={errors.otherTypeSpecification ? "validation-error-border" : ""}
      />
      <ErrorMessage error={errors.otherTypeSpecification} />
    </div>
  );
};

export default OtherTypeSpecificationField;
